import React from 'react';
import { LEGAL_PRIVACY_STAND_ANZEIGE } from "../config/legal";

const Datenschutz = () => {
  return (
    <div className="myn-legal">
      <div className="myn-card">
        <h1 className="myn-h2">Datenschutzerklärung</h1>

        <div className="myn-prose">
          <p className="text-muted small">Stand: {LEGAL_PRIVACY_STAND_ANZEIGE}</p>
          <p>
            Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend
            informieren wir Sie gemäß der Datenschutz-Grundverordnung (DSGVO) über
            Art, Umfang und Zweck der Verarbeitung personenbezogener Daten innerhalb
            unseres Angebots MYN.CLUB.
          </p>

          <h2>1. Verantwortlicher</h2>
          <p>
            EDEL Investment GmbH<br />
            Marienburger Str. 2D<br />
            40789 Monheim am Rhein, Deutschland<br />
            E-Mail: <a href="mailto:edelabcmail@gmail.com">edelabcmail@gmail.com</a>
          </p>

          <h2>2. Erhebung und Verarbeitung von Daten</h2>
          <p>
            Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung
            einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
            erforderlich ist. Bei der Registrierung und Nutzung Ihres Kontos
            verarbeiten wir die von Ihnen angegebenen Daten (z. B. Benutzername,
            E-Mail-Adresse) zur Vertragserfüllung gemäß Art. 6 Abs. 1 lit. b DSGVO.
          </p>

          <h2>2a. Kostenloser Test-QR-Code auf der Startseite</h2>
          <p>
            Wenn Sie auf der Startseite ohne Registrierung einen Test-QR-Code
            erzeugen, verarbeiten wir den Namen und die Adresse des von Ihnen
            gewählten Unternehmens, gerundete Koordinaten sowie die Standortkennung
            des Kartendienstes (nur intern, nicht sichtbar). Zusätzlich speichern
            wir den Zeitpunkt Ihrer Zustimmung und die Fassung der akzeptierten AGB
            und Datenschutzerklärung. Zu dem Unternehmen ergänzen wir öffentlich
            verfügbare Angaben und ein Kartenbild (siehe Punkt 2b). Es werden keine
            Kontaktdaten und keine IP-Adresse der testenden Person zu diesem
            Vorgang gespeichert.
          </p>
          <p>
            Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die
            Sie vor dem Erzeugen über ein Kontrollkästchen erteilen. Mit der
            Einwilligung stimmen Sie zu, dass Firmenname, Adresse und das
            Kartenbild (Punkt 2b) öffentlich im Bereich „Gerade erzeugt“ auf der
            Startseite und auf einer Visitenkarten-Seite des Unternehmens angezeigt
            werden. Nach Ablauf des Testzeitraums wird der Test-Code automatisch
            freigegeben; der Eintrag bleibt jedoch weiterhin öffentlich sichtbar
            und verweist dann auf die Visitenkarte. Wir können einen abgelaufenen
            Test-Code für einen begrenzten Zeitraum erneut aktivieren. Sie können
            die Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen;
            schreiben Sie dazu an die unter Punkt 9 genannte Adresse. Der Eintrag
            wird dann ausgeblendet bzw. gelöscht.
          </p>

          <h2>2b. Öffentliche Unternehmensangaben und Kartenbild</h2>
          <p>
            Damit das Unternehmen im Bereich „Gerade erzeugt“ erkennbar dargestellt
            wird, verarbeiten wir zu dem gewählten Unternehmen folgende öffentlich
            verfügbare Angaben:
          </p>
          <ul>
            <li>
              <strong>Angaben aus Google Maps:</strong> Website, Branche,
              Kategorien bzw. Leistungen und Kurzbeschreibung des Unternehmens. Wir
              rufen diese Angaben serverseitig über die Google Places API (Google
              Ireland Limited) ab; dabei wird nur die Standortkennung des
              Unternehmens übermittelt, keine Daten über Sie als Besucher. Die
              Angaben werden bei einem erneuten Test frühestens nach 30 Tagen
              aktualisiert und mit dem Eintrag gelöscht.
            </li>
            <li>
              <strong>Kartenbild bei vorhandener Website:</strong> Wir übernehmen das
              Vorschaubild, das die Website selbst für die Anzeige in sozialen
              Netzwerken und Suchmaschinen bereitstellt. Ist keines vorhanden,
              erstellen wir eine verkleinerte Bildschirmaufnahme der Startseite der
              Website. Der Abruf erfolgt einmalig durch unseren Server ohne
              Anmeldung und ohne dauerhafte Speicherung von Cookies;
              das Bild wird auf unserem Server gespeichert, damit beim Besuch
              unserer Seite keine Daten an die fremde Website übertragen werden.
              Solche Bilder sind als „Website-Vorschau“ gekennzeichnet.
            </li>
            <li>
              <strong>KI-generiertes Kartenbild ohne Website:</strong> Ist keine
              Website vorhanden, lassen wir ein illustratives Bild durch einen
              KI-Dienst erzeugen (siehe Punkt 5a). Dafür übermitteln wir
              ausschließlich Firmenname, Branche, Leistungen, Kurzbeschreibung und
              Ort des Unternehmens. Solche Bilder sind als „KI-generiert“
              gekennzeichnet.
            </li>
          </ul>
          <p>
            Hat das Unternehmen einen eigenen Werbeflyer hinterlegt, wird statt des
            Kartenbildes der Flyer angezeigt. Rechtsgrundlage ist Ihre Einwilligung
            (Art. 6 Abs. 1 lit. a DSGVO, siehe Punkt 2a). Soweit Angaben eines
            Unternehmens verarbeitet werden, für das die Einwilligung nicht von
            einer berechtigten Person erteilt wurde, stützen wir uns auf unser
            berechtigtes Interesse an einer verständlichen Darstellung der
            erzeugten Test-Codes (Art. 6 Abs. 1 lit. f DSGVO). Inhaber eines
            Unternehmens bzw. einer Website können der Verarbeitung und der Anzeige
            des Kartenbildes jederzeit widersprechen (Art. 21 DSGVO); schreiben Sie
            dazu an die unter Punkt 9 genannte Adresse. Das Bild und die ergänzten
            Angaben werden dann gelöscht. Wird ein Eintrag endgültig entfernt,
            löschen wir auch das zugehörige Kartenbild.
          </p>

          <h2>3. Server-Logfiles</h2>
          <p>
            Beim Aufruf unserer Seiten werden automatisch technische Zugriffsdaten
            (z. B. IP-Adresse, Datum und Uhrzeit, Browsertyp und Betriebssystem)
            verarbeitet. Dies dient der Sicherstellung eines störungsfreien Betriebs
            und der Sicherheit unserer Systeme (Art. 6 Abs. 1 lit. f DSGVO).
          </p>

          <h2>4. Cookies</h2>
          <p>
            Wir verwenden Cookies, um die Benutzerfreundlichkeit zu verbessern.
            Technisch notwendige Cookies werden auf Grundlage unseres berechtigten
            Interesses gesetzt. Weitere Cookies setzen wir nur mit Ihrer Einwilligung,
            die Sie jederzeit über den Cookie-Hinweis steuern können.
          </p>

          <h2>5. Google Maps</h2>
          <p>
            Zur Darstellung von Karten nutzen wir den Dienst Google Maps der Google
            Ireland Limited. Beim Aufruf der Karte können Daten (insbesondere Ihre
            IP-Adresse) an Google übermittelt werden. Weitere Informationen finden Sie
            in der{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
              Datenschutzerklärung von Google
            </a>.
          </p>

          <h2>5a. KI-Bilderzeugung (OpenAI)</h2>
          <p>
            Für die unter Punkt 2b beschriebenen KI-generierten Kartenbilder nutzen
            wir die Programmierschnittstelle von OpenAI (OpenAI Ireland Ltd.,
            Dublin, bzw. OpenAI, L.L.C., San Francisco, USA). Übermittelt werden
            ausschließlich die dort genannten Unternehmensangaben, keine Daten über
            Sie als Besucher oder testende Person. Eine Übermittlung in die USA ist
            dabei nicht ausgeschlossen; sie erfolgt auf Grundlage des mit OpenAI
            geschlossenen Auftragsverarbeitungsvertrags einschließlich der
            EU-Standardvertragsklauseln (Art. 46 DSGVO). Nach Angaben von OpenAI
            werden über die Programmierschnittstelle übermittelte Daten nicht zum
            Training von KI-Modellen verwendet. Weitere Informationen finden Sie in
            der{" "}
            <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noreferrer">
              Datenschutzerklärung von OpenAI
            </a>.
          </p>

          <h2>6. Zahlungsabwicklung (Stripe)</h2>
          <p>
            Für die Abwicklung von Zahlungen setzen wir den Dienstleister Stripe ein.
            Die im Rahmen des Zahlungsvorgangs eingegebenen Daten werden ausschließlich
            an Stripe übermittelt und dort verarbeitet. Es gelten die Datenschutzhinweise
            von Stripe.
          </p>

          <h2>7. Ihre Rechte</h2>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
            Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen die Verarbeitung
            Ihrer Daten. Zudem steht Ihnen ein Beschwerderecht bei einer
            Datenschutz-Aufsichtsbehörde zu.
          </p>

          <h2>8. Datensicherheit</h2>
          <p>
            Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten gegen
            Verlust, Manipulation und unberechtigten Zugriff zu schützen. Die
            Übertragung erfolgt verschlüsselt über aktuelle Sicherheitsstandards.
          </p>

          <h2>9. Kontakt zum Datenschutz</h2>
          <p>
            Bei Fragen zum Datenschutz erreichen Sie uns unter{" "}
            <a href="mailto:edelabcmail@gmail.com">edelabcmail@gmail.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
